import * as URLConfig from "../domain";

const config = URLConfig.config;
const loginURLConfig = {
  CommKambala: true,
  accounts: config.jmw + config.jmw_login + "accounts/",
  loginHelp: config.jmw + config.jmw_login + "loginhelp/",
  account: config.jmw + config.jmw_login + "account/",
  consent: config.jmw + config.jmw_login + "consent/",
  submitConsent: config.jmw + config.jmw_login + "loginconsent/",
  merge: config.jmw + config.jmw_login + "merge/",
  raterm: config.jmw + config.jmw_login + "raterm/",
  commAccOpen: config.jmw + config.jmw_login + "commodity/openaccount/",
  adhoc: config.jmw + config.jmw_content + "adhoc/",
  locateUS: config.jmw + 'app-marketstats/locateUs',

  // Vendor login
  vendor_login: config.key_clock_vendor + "auth/vendor/token",
  vendor_forget_password:
    config.key_clock_vendor + "vendor/users/forgot-password",
  vendor_reset_password:
    config.key_clock_vendor + "vendor/users/reset-password",
  openAccount: config.openNewAcc,
  getServerKey: config.key_clock_vendor + "keys/server-public-key",

  // E-TOTP base url|
  etotpBaseUrl: config.jmw + config.jmw_login + "etotp/"
};

export default loginURLConfig;
